import { Injectable } from '@angular/core';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private segmentService: SegmentService) {}

  trackEvent(event: EventTypes, metadata?: Record<string, any>): void {
    const defaultContext = { platform: 'web', ...metadata };
    void EventNotifierService.notify(new DashpivotEvent(event, defaultContext), this.segmentService);
  }
}
